import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-edge-message',
    templateUrl: './edge-message.component.html',
    styleUrls: ['./edge-message.component.scss']
})
export class EdgeMessageComponent implements OnInit {

    constructor(/*++++++++++++++++++++++++++++++++++++++++++*/
                public dialog: MatDialog
                /*++++++++++++++++++++++++++++++++++++++++++*/) {
    }

    ngOnInit() {
    }

}
